import { useCallback, useEffect } from "react"
import { useNavigate, useParams } from "react-router"
import { Alert, Spin } from "antd"
import { TempLayout } from "@/layouts"
import ApprovalActions from "@/atoms/approval-actions"
import { useSapReservationStore } from "@/stores/sap-reservation/sapReservationStore"
import SapReservationDetailView from "./components/SapReservationDetailView"

const SapReservationsDetail = () => {
  const { recordId } = useParams()
  const navigate = useNavigate()
  const { fetchSapReservationById, currentReservation, isLoading, error } = useSapReservationStore()

  const sanitizedApprovalData = currentReservation
    ? {
        status: 200,
        data: currentReservation.approval_process_id,
      }
    : undefined

  const sanitizedReservationDetail = currentReservation
    ? {
        ...currentReservation,
        approval_process_id: sanitizedApprovalData,
      }
    : null

  const handleApproveClick = () => {
    navigate("/saprsv/history")
  }

  const fetchReservationById = useCallback(async () => {
    if (recordId) {
      await fetchSapReservationById(recordId)
    }
  }, [fetchSapReservationById, recordId])

  useEffect(() => {
    void fetchReservationById()
  }, [fetchReservationById])

  useEffect(() => {
    const requesterName = currentReservation?.fullname?.trim()
    const currentRecordId = currentReservation?.record_id || recordId || ""
    document.title = requesterName ? `${requesterName} - SAP Reservation${currentRecordId ? ` (${currentRecordId})` : ""}` : "SAP - Reservation Detail"

    return () => {
      document.title = "FARMS Application"
    }
  }, [currentReservation?.fullname, currentReservation?.record_id, recordId])

  return (
    <TempLayout title="SAP - Reservation Detail" navNavigateUrl="/saprsv/history">
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 50 }}>
          <Spin />
        </div>
      ) : error ? (
        <Alert message="Error" description={error} type="error" showIcon />
      ) : sanitizedReservationDetail ? (
        <SapReservationDetailView data={sanitizedReservationDetail} />
      ) : (
        <Alert message="Not Found" description="Reservation not found or ID missing" type="warning" showIcon />
      )}

      {currentReservation ? (
        <ApprovalActions canEditData={false} mainData={sanitizedReservationDetail} onApproveClick={handleApproveClick} />
      ) : null}
    </TempLayout>
  )
}

export default SapReservationsDetail
